'use client';

import { LicenseInfo } from '@mui/x-license';

import { MUI_X_LICENSE_KEY } from './licenseKey';

LicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY);

/**
 * Render once near the app root, above any MUI X Pro component. The key is set when this
 * module loads, so the component itself renders nothing.
 */
export default function MuiXLicense(): null {
	return null;
}
